import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentPlanResponse } from '../../../models/responses/payment-plan-response';
import { PaymentPlanService } from '../../../services/payment-plan.service';

@Component({
  selector: 'app-custom-payment-plan',
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatDialogModule,
    NgFor
  ],
  templateUrl: './custom-payment-plan.component.html',
  styleUrl: './custom-payment-plan.component.scss'
})
export class CustomPaymentPlanComponent {
  @Input() plans!: PaymentPlanResponse[];
  @Input() isPurchaseMode!: boolean;
  constructor(private paymentPlanService: PaymentPlanService) { }

  onPlanSelected(plan: PaymentPlanResponse) {
    this.paymentPlanService.createCustomPlanStripeUrl(plan.monthlyPriceId).subscribe({
      next: (url) => {
        document.location.href = url.url;
      },
      error: () => {
        alert('Server error, contact support');
      }
    })
  }
}
